import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../../../../store/store';

type Props = {
  engagementId: string;
  branchId: string;
};

export const LinkToThreadRow: React.FC<Props> = ({
  engagementId,
  branchId,
}): JSX.Element => {
  const user = useSelector((state: RootState) => state.auth.user);
  const history = useHistory();

  const goToThread = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (
      engagementId?.length &&
      branchId?.length &&
      user?.userId &&
      user?.orgId
    ) {
      const { userId, orgId } = user;
      history.push(
        `/orgs/${orgId}/users/${userId}/engagements/${engagementId}/threads/${branchId}`
      );
    }
  };

  return (
    <div className="open-thread-row" onClick={(e) => goToThread(e)}>
      Open
    </div>
  );
};
